import React, { useEffect, useRef, useState } from 'react'
import styles from './Home.module.scss'
import Header from '../../Components/Header/Header.tsx'
import { IApart, IApartRef, IApartShort, IInfrastructure, INavService, IReveiw, IService, services } from '../../Types/Models/types.tsx'
import { collection, getDocs } from 'firebase/firestore'
import { db, storage } from '../../firebase.js'
import { getDownloadURL, listAll, ref } from 'firebase/storage'
import CardApart from '../../Components/CardApart/CardApart.tsx'
import InfrastructureCard from '../../Components/InfrastructureCard/InfrastructureCard.tsx'
import ReveiwsSlider from '../../Components/ReveiwsSlider/ReveiwsSlider.tsx'
import Footer from '../../Components/Footer/Footer.tsx'
import FullService from '../../Components/FullService/FullService.tsx'
import Book from '../../Components/Book/Book.tsx'
import { useLocation } from 'react-router-dom'
import { Virez } from '../../Components/Virez/Virez.tsx'
import Parallax from '../../Components/Parallax/Parallax.tsx'
import { BNOVO_HORIZONTAL_CONTAINER_ID, BNOVO_VERTICAL_CONTAINER_ID, initBnovoWidgets } from '../../_bnovo.ts'

interface IAllInfrastructures {
  rest: IInfrastructure[],
  bars: IInfrastructure[],
  spa: IInfrastructure[],
}

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  const [initialHeight, setInitialHeight] = useState(window.innerHeight)
  const mobilePadding = 25;
  const [pageWidth, setPageWidth] = useState(window.innerWidth)
  const [device, setDevice] = useState<number>(() => {
    const width = window.innerWidth;
    if (width <= 600) {
      return (0);
    }
    else if (width <= 792) {
      return (1)
    }
    else if (width <= 850) {
      return (2)
    }
    else if (width <= 1260) {
      return (3)
    }
    else return (4)
  });
  const [aparts, setAparts] = useState<IApartShort[]>();
  const [infrastrucures, setInfrastructures] = useState<IAllInfrastructures>({
    rest: [],
    bars: [],
    spa: [],
  })
  const [currentInfra, setCurrentInfra] = useState<string>("rest");
  const [pendingAparts, setPendingAparts] = useState(true);
  const [pendingInfra, setPendingInfra] = useState(true);
  const slider = useRef<HTMLDivElement>(null);
  const [canGoRightSliderInfra, setCanGoRightSliderInfra] = useState(true);
  const [canGoLeftSliderInfra, setCanGoLeftSliderInfra] = useState(false);
  const [currentIndexInfra, setCurrentIndexInfra] = useState(0);
  const [isOpenBook, setIsOpenBook] = useState(false);
  const [wantedApart, setWantedApart] = useState<IApart>();
  const [openedService, setOpenedService] = useState<IService>()
  const [wantedService, setWantedService] = useState<IService>();
  const bookref = useRef<HTMLDivElement>(null);
  const [showMobileBook, setShowMobileBook] = useState(false);
  const nav_services = [
    { name: "Чем заняться в Москва Сити", icon: "/images/rest_black.svg", link: "#Infrasctructure" },
    { name: "Наши отзывы", icon: "/images/like_black.svg", link: "#Reveiws" },
    { name: "Контакты", icon: "/images/contacts.svg", link: "#Contacts" },
  ] as INavService[]

  const [scroll, setScroll] = useState(0)

  const updateObserver = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting)
          entry.target.classList.add(styles.animation_show)
        else {
          // entry.target.classList.remove(styles.animation_show)
        }
      });
    }, { threshold: 0.3 }); // 0.1 означает, что 10% элемента должно быть видно

    document.querySelectorAll(`.${styles.animation}`).forEach((i) => {
      if (i) {
        observer.observe(i);
      }
    });
  }
  useEffect(() => {
    initBnovoWidgets();

    updateObserver();

    const CheckDevice = () => {
      const width = window.innerWidth;
      setPageWidth(width);
      if (width <= 600) setDevice(0);
      else if (width <= 792) setDevice(1);
      else if (width <= 900) setDevice(2);
      else if (width <= 1260) setDevice(3);
      else setDevice(4);
    };
    const scroll = () => {
      setScroll(window.scrollY)
    }
    const tempAparts: IApartShort[] = [];
    // Если у вас в IApart / IApartRef еще нет поля id, рекомендую его добавить:
    // interface IApart { id: string; ... } 
    // interface IApartRef { id: string; ... }

    const fetchAparts = async () => {
      try {
        // Устанавливаем статус загрузки основных данных
        setPendingAparts(true);

        const querySnapshot = await getDocs(collection(db, "aparts"));

        // 1. Получаем все данные и сразу добавляем к ним id документа
        const apartsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        })) as (IApartRef & { id: string })[];

        // Сортировка: выносим "Китай-город" на 3-ю позицию (индекс 2)
        const towerIndex = apartsData.findIndex((apart) => apart.tower === "Китай-город");
        if (towerIndex !== -1) {
          const [targetObject] = apartsData.splice(towerIndex, 1);
          apartsData.splice(2, 0, targetObject);
        }

        // Формируем начальный массив для рендера (без картинок)
        const initialAparts: IApartShort[] = apartsData.map(myApartRef => ({
          id: myApartRef.id,
          tower: myApartRef.tower,
          price: myApartRef.price,
          area: myApartRef.area,
          floor: myApartRef.floor,
          Name: myApartRef.Name,
          description: myApartRef.description,
          images: [], // Пустой массив для отрисовки скелетонов
          location: myApartRef.location,
          color: myApartRef.color,
          rooms: myApartRef.rooms,
          discount: myApartRef.discount
        } as IApartShort));

        // Сразу отдаем данные в стейт, чтобы UI отрисовал карточки
        setAparts(initialAparts);
        setPendingAparts(false);

        // 2. Начинаем подгрузку картинок чанками по 2 апартамента
        const CHUNK_SIZE = 2;

        for (let i = 0; i < apartsData.length; i += CHUNK_SIZE) {
          // Берем срез из 2 элементов
          const chunk = apartsData.slice(i, i + CHUNK_SIZE);

          // Запрашиваем картинки для текущей "двойки" параллельно
          const chunkPromises = chunk.map(async (myApartRef) => {
            try {
              const shortImgRef = ref(storage, myApartRef.img + "/Short");
              const shortImgs = await listAll(shortImgRef);

              const urlPromises = shortImgs.items.map(item => getDownloadURL(item));
              const urls = await Promise.all(urlPromises);

              // Возвращаем id апартамента и загруженные ссылки
              return { id: myApartRef.id, urls };
            } catch (error) {
              console.error(`Ошибка загрузки фото для ${myApartRef.tower}:`, error);
              return { id: myApartRef.id, urls: [] }; // Возвращаем пустой массив при ошибке
            }
          });

          // Ждем, пока загрузятся картинки для текущих 2 апартаментов
          const chunkResults = await Promise.all(chunkPromises);

          // 3. Обновляем стейт новыми картинками
          // Используем callback форму setAparts, чтобы не потерять предыдущие обновления
          setAparts((prevAparts) =>
            prevAparts?.map((apart) => {
              // Ищем, есть ли в только что загруженном чанке картинки для текущего апартамента
              const updatedImages = chunkResults.find((res) => res.id === apart.id);

              if (updatedImages && updatedImages.urls.length > 0) {
                return { ...apart, images: updatedImages.urls };
              }
              return apart;
            })
          );
        }

      } catch (error) {
        console.error("Ошибка при получении данных:", error);
        setPendingAparts(false);
      }
    };

    const fetchInrastructure = async () => {
      try {
        const querySnapshotRest = await getDocs(collection(db, "intert_rest"));
        const infraDataRest: IInfrastructure[] = querySnapshotRest.docs.map((doc) => ({
          ...doc.data()
        })) as IInfrastructure[];
        setInfrastructures((prev) => ({
          ...prev,
          rest: infraDataRest,
        }));

        const querySnapshotBars = await getDocs(collection(db, "inrert_bar"));
        const infraDataBars: IInfrastructure[] = querySnapshotBars.docs.map((doc) => ({
          ...doc.data()
        })) as IInfrastructure[];
        setInfrastructures((prev) => ({
          ...prev,
          bars: infraDataBars,
        }));

        const querySnapshotSpa = await getDocs(collection(db, "intert_spa"));
        const infraDataSpa: IInfrastructure[] = querySnapshotSpa.docs.map((doc) => ({
          ...doc.data()
        })) as IInfrastructure[];
        setInfrastructures((prev) => ({
          ...prev,
          spa: infraDataSpa,
        }));
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      } finally {
        setPendingInfra(false);
        updateObserver();
      }
    };
    fetchAparts();
    fetchInrastructure();

    CheckDevice();
    const updateHeight = () => {
      setInitialHeight(window.innerHeight)
    }
    let resizeTimer: number;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      // Срабатывает только через 150мс после того, как пользователь закончил тянуть окно
      resizeTimer = setTimeout(() => {
        CheckDevice();
      }, 150);
    };

    window.addEventListener("orientationchange", updateHeight)
    window.addEventListener("resize", handleResize)
    document.addEventListener("scroll", scroll)


    return () => {
      window.removeEventListener("orientationchange", updateHeight)
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("scroll", scroll);
    };
  }, [])

  useEffect(() => {
    updateObserver();
  }, [aparts?.length, infrastrucures])

  const updateScrollInfra = () => {
    if (slider.current) {
      console.log(slider.current.scrollLeft)
      setCurrentIndexInfra(Math.floor(slider.current.scrollLeft / 400));
      if (slider.current?.scrollLeft > 0) {
        setCanGoLeftSliderInfra(true);
      }
      else {
        setCanGoLeftSliderInfra(false)
      }
      console.log(slider.current.scrollLeft, slider.current.scrollWidth, slider.current.clientWidth)
      if ((slider.current.scrollLeft + 20 < slider.current.scrollWidth - slider.current.clientWidth) || slider.current.scrollWidth === slider.current.clientWidth) {
        setCanGoRightSliderInfra(true);
      }
      else {
        setCanGoRightSliderInfra(false)
      }
    }
  }
  useEffect(() => {
    if (slider.current) {
      updateScrollInfra();
    }
  }, [slider.current]);

  const handleScrollSliderInfra = (right: boolean) => {
    if (slider.current) {
      if (right) {
        slider.current.scrollTo({
          left: 450 * (currentIndexInfra + 1), // Полная ширина содержимого
          behavior: 'smooth', // Гладкая анимация
        });
      }
      else {
        slider.current.scrollTo({
          left: 450 * (currentIndexInfra - 1), // Полная ширина содержимого
          behavior: 'smooth', // Гладкая анимация
        });
      }
    }
  }

  useEffect(() => {
    if (openedService || isOpenBook) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflowY = "hidden";
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }
    else if (!openedService && !isOpenBook) {
      document.body.style.overflowY = "";
      document.body.style.paddingRight = "";
    }
    if (!isOpenBook) {
      setWantedApart(undefined);
    }
  }, [openedService, isOpenBook])

  useEffect(() => {
    if (!isOpenBook) {
      setWantedService(undefined)
    }
  }, [isOpenBook])

  useEffect(() => {
    if (wantedApart || wantedService) {
      setIsOpenBook(true);
    }
  }, [wantedApart, wantedService])


  const [fixedMobile, setFixedMobile] = useState(false);
  useEffect(() => {
    if (bookref.current) {
      if (device > 2 && scroll > window.innerHeight) {
        bookref.current.classList.add(styles.fixed);
      }
      else {
        bookref.current.classList.remove(styles.fixed);
        setFixedMobile(false);
      }
    }
    if (scroll > 1100) {
      setShowMobileBook(true)
    }
    else {
      setShowMobileBook(false)
    }
  }, [scroll, device])

  return (
    <div className={styles.Home} id='Main' style={{ width: "100%", overflow: "hidden" }}>
      {/* <Header home /> */}
      <div className={`${styles.mobileBookSverhu} ${showMobileBook ? styles.show : ""}`}>
        <a href='#Book'>Выбрать даты</a>
      </div>
      {openedService &&
        <div className={styles.WrapperFullService}>
          <FullService setWantedService={setWantedService} service={openedService} setOpenedService={setOpenedService} />
        </div>
      }
      {isOpenBook &&
        <div className={styles.WrapperFullService}>
          <div className={styles.Inner}>
            <Book apart={wantedApart} wantedService={wantedService} setIsOpenBook={setIsOpenBook} />
          </div>
        </div>
      }
      <div className={styles.WelcomeBlockWrapper}>
        <div className={`${styles.WelcomeBlock}`}>
          <Parallax device={device} />
        </div>
        <div className={`${styles._orderBlock} ${fixedMobile ? styles.fixedMobile : ""}`} ref={bookref}>
          {/* Горизонтальный контейнер */}

          <div className="anchorBook" style={{ position: "absolute", top: '-100px' }} id='Book'></div>
          <div
            id={BNOVO_HORIZONTAL_CONTAINER_ID}
            className={`${styles.bnovoContainer} ${(device <= 2) ? styles.hiddenWidget : ''}`}
          />

          {/* Вертикальный контейнер */}
          <div
            id={BNOVO_VERTICAL_CONTAINER_ID}
            className={`${styles.bnovoContainer} ${(device > 2) ? styles.hiddenWidget : ''}`}
          />
        </div>
      </div>
      <div className={`${styles.ApartsBlock} ${pendingAparts ? styles.Pending : ""}`} id='Aparts'>
        <div className={`${styles.Content}`}>
          <div className={styles.TopBlock}>
            <span className={`${styles.BlockTitle} ${styles.Big} ${styles.Bold} ${styles.animation}`}>Коллекция апартаментов</span>
            <div className={`${styles.Info} ${styles.animation}`}>
              <img src='/images/sleep_black.svg' />
              <span>Оставьте заявку на бронирование на сайте, и мы свяжемся с Вами в самое ближайшее время. Либо
                свяжитесь с нами и назовите апартаменты, которые вам понравились.
              </span>
            </div>
          </div>
          {pendingAparts ?
            <div className={`${styles.animation} ${styles.LoadingBlock}`}>
              <img src='/images/loading.svg'></img>
            </div>
            :
            <div className={`${styles.Aparts}`}>
              {aparts?.map((apart, index) =>
                <div key={apart.Name} className={`${styles.CardWrapper} ${styles.animation}`} style={{
                  transitionDelay: index % 3 * 0.1 + "s",
                }}>
                  <CardApart setWantedApart={setWantedApart} device={device} pageWidth={pageWidth} paddingMobile={mobilePadding} apart={apart} />
                </div>
              )}
            </div>
          }
        </div>
      </div>
      <div className={styles.ServiceBlock} id='Services'>
        <div className={styles.Content}>
          <div className={styles.TopBlock}>
            <span className={`${styles.BlockTitle} ${styles.Big} ${styles.Bold} ${styles.animation}`}>Услуги Cozy Aparts</span>
            <a href='#Aparts' className={`${styles.GoAparts} ${styles.animation}`}>{`К выбору апартаментов`}</a>
          </div>
          <div className={`${styles.Services}`}>
            {services.map((item, index) => (
              <div key={item.title} style={{
                transitionDelay: index % 3 * 0.1 + "s",
              }} className={`${styles.Service} ${item.className ? styles[item.className] : ""} ${styles.animation}`}>
                <img src={item.image} alt={item.title} className={styles.Icon} />
                <p className={`${styles.Middle} ${styles.Bold}`}>{item.title}</p>
                <p className={`${styles.Thin}`}>{item.shortText}</p>
                <img className={styles.Background} src={item.background}></img>
                <button onClick={() => {
                  setOpenedService(item)
                }} className={`${styles.Regular} ${styles.Expand}`} >
                  <Virez color='theme' height={60} padding={20} />
                  <div className={styles.ContentButton}>
                    Подробнее
                  </div>
                </button>
              </div>
            ))}
          </div>
          <nav className={styles.ServiceNavs}>
            <ul>
              {nav_services.map((item) =>
                <li key={item.name} className={`${styles.Nav} ${styles.animation}`}>
                  <a href={item.link}>
                    {/* <img className={styles.Icon} src={item.icon}></img> */}
                    <span className={`${styles.Middle} ${styles.Regular}`}>{item.name}</span>
                    <img className={styles.Arrow} src='/images/arrow_black.svg' />
                  </a>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
      {/* <div className={styles.FeastBlock}>
        <div className={styles.Content}>
          <div className={styles.Text}>
            <img className={styles.Feautures} src='/images/feast_feautures.png' />
            <span className={`${styles.Middle} ${styles.Bold}`}>Праздник с Cozy Aparts</span>
            <ul className={styles.List}>
              <li><span className={``}>+ Увеличенный безлимитный мини-бар</span></li>
              <li><span className={``}>+ PlayStation 5 и настольные игры</span></li>
              <li><span className={``}>+ Колонка Алиса</span></li>
              <li><span className={``}>+ Количество гостей до 15 без ограничений</span></li>
            </ul>
            <button className={`${styles.Regular} ${styles.Expand}`} >
              <Virez reverse height={60} padding={20} />
              <div className={styles.ContentButton}>
                Подробнее
              </div>
            </button>
          </div>
          <div className={styles.BackgroundBlock}>
            <img className={styles.Background} src='/images/feast.webp' />
            <div className={styles.Fade} />
          </div>
        </div>
      </div> */}
      <div className={`${styles.InfrascructureBlock} ${pendingInfra ? styles.Pending : ""}`} id='Infrasctructure'>
        <div className={styles.TopBlock}>
          <span className={`${styles.BlockTitle} ${styles.Big} ${styles.Bold} ${styles.animation}`}>Инфраструктура Сити</span>
          <div className={`${styles.InfraButtons} ${styles.animation}`}>
            {[{ name: "Рестораны", ref: "rest" }, { name: "Бары", ref: "bars" }, { name: "СПА", ref: "spa" }].map((infra, index) =>
              <button key={infra.name} onClick={() => {
                setCurrentInfra(infra.ref)
                if (slider.current) {
                  slider.current.scrollLeft = 0;
                }
              }}
                className={`${styles[infra.ref]} ${currentInfra === infra.ref ? styles.infra_active : ""}`}
              >{infra.name}</button>
            )}
          </div>
        </div>
        {pendingInfra ?
          <div className={`${styles.LoadingBlock} ${styles.animation}`}>
            <img src='/images/loading.svg'></img>
          </div>
          :
          <div className={`${styles.Content} ${styles.animation}`} ref={slider} onScroll={updateScrollInfra}>
            <div className={styles.Infras}>
              <div className={styles.Slider} style={{
                // width: 366 * infrastrucures[currentInfra].length + 50 * (infrastrucures[currentInfra].length - 1) + "px"
              }}>
                <div className={styles.SlideContent}>
                  {
                    //@ts-ignore
                    infrastrucures[currentInfra].map((infra, index) =>
                      <div className={`${styles.WrapperInfra}`} key={infra.Name}>
                        <InfrastructureCard key={infra.Name} infrastructure={infra} icon={currentInfra} index={index} />
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        }
        <div className={styles.ButtonsBlock}>
          <button onClick={() => handleScrollSliderInfra(false)} className={`${styles.LeftButton} ${!canGoLeftSliderInfra ? styles.hide : ""}`}></button>
          <button onClick={() => handleScrollSliderInfra(true)} className={`${styles.RightButton} ${!canGoRightSliderInfra ? styles.hide : ""}`}></button>
        </div>
      </div>
      <div className={`${styles.ReveiwsBlock}`} id='Reveiws'>
        <div className={styles.TopBlock}>
          <span className={`${styles.BlockTitle} ${styles.Big} ${styles.Bold} ${styles.animation}`}>Наши отзывы</span>
          <div className={`${styles.Info} ${styles.animation}`}>
            <img src='/images/info.svg' />
            <span>Мы размещаем ссылки на площадки бронирования, чтобы Вы могли ознакомиться с отзывами наших гостей и убедиться в качестве наших апартаментов.
              Однако, бронируя через наш сайт напрямую, Вам не придется оплачивать дополнительные комиссии, которые взимаются на сторонних платформах.</span>
          </div>
        </div>
        <div className={`${styles.Content} ${styles.animation}`}>
          <ReveiwsSlider />
        </div>
        <div className={`${styles.Reccomend}  ${styles.animation}`}>
          <a className={styles.RecommendItem} target="_blank" id="hotels101_partner_widget_97"
            style={{
              textDecoration: "none",
              display: "block",
              height: "60px",
              width: "300px"
            }}
            href="https://101hotels.com/main/cities/moskva/apartamenti_cozy_aparts_moscow_city.html">
          </a>
        </div>
      </div>
      <div className={styles.ContantsBlock} id='Contacts'>
        <div className={styles.Content}>
          <div className={styles.TopBlock}>
            <span className={`${styles.BlockTitle} ${styles.Big} ${styles.Bold} ${styles.animation}`}>Контакты и правила</span>
          </div>
          <div className={`${styles.Blocks} ${styles.animation}`}>
            <div className={`${styles.Block} ${styles.Contacts}`}>
              <div className={styles.Top}>
                <img src='/images/contacts.svg' className={styles.icon}></img>
                <span className={`${styles.Middle} ${styles.Bold}`}>Контакты</span>
                <ul className={`${styles.Text} ${styles.ContactsList}`}>
                  <li className={styles.phone}><a href='tel:+79299023710' target='_blank'>+7 929 902 3710</a></li>
                  <li className={styles.tg}><a href='https://t.me/cozzyaparts' target='_blank'>@cozzyaparts</a></li>
                  <li className={styles.mail}><a href='mailto:cozyaparts@yandex.ru' target='_blank'>cozyaparts@yandex.ru</a></li>
                </ul>
              </div>
              <div className={`${styles.bottom} ${styles.Regular}`}>
                <Virez height={60} padding={20} color='theme' />
                <a href='https://t.me/cozzyaparts' target='_blank'><img src='/images/tg_full.svg' /></a>
                <a href="https://wa.me/79299023710" target="_blank"><img src='/images/whatsapp_full.svg' /></a>
              </div>
            </div>
            <div className={`${styles.Block} ${styles.Rules}`}>
              <div className={styles.Top}>
                <div className={styles.Left}>
                  <img src='/images/rules.svg' className={styles.icon}></img>
                  <span className={`${styles.Middle} ${styles.Bold}`}>Правила заселения</span>
                  <span className={`${styles.Text}`}>
                    Цена указана при бронировании в будние дни до 2-х человек, сверх этого количества доплата за гостей - 1500₽/гость/сутки<br /><br />
                    Заезд с 15:00<br />
                    Выезд до 12:00<br /><br />
                    Поздний выезд и ранний заезд возможен по договорённости. Стоимость - 1300₽/час<br /><br />
                    <span className={`${styles.Bold} ${styles.Middle}`} style={{
                      marginBottom: "15px",
                      display: "inline-block",
                      marginTop: "15px"
                    }}>Залог </span><br />
                    10,000₽ - стандартный<br />
                    20,000₽ - при проведении мероприятий<br /><br />
                  </span>
                </div>
                <div className={styles.Right}>
                  <span className={`${styles.Middle} ${styles.Bold}`}>Парковка</span>
                  <span className={`${styles.Text}`}>
                    Вы можете оставить машину в башне "Neva Towers 1". Стоимость парковки: 4,500₽/сутки<br /><br />
                    <span className={`${styles.Bold} ${styles.Middle}`} style={{
                      marginBottom: "15px",
                      display: "inline-block",
                      marginTop: "15px"
                    }}>Документы </span><br />
                    Во всех башнях проход по документам. Убедитесь, что у вас с собой паспорт или водительское удостоверение. <br /> <br />
                    Для детей младше 14 лет - свидетельство о рождении<br /><br />
                    Отчетные документы предоставляются по запросу
                  </span>
                </div>
              </div>
              <a href='#Aparts' className={`${styles.ChooseAparts} ${styles.Regular}`}>
                <Virez height={60} padding={20} color='theme' />
                <div className={styles.ContentButton}>
                  Выбрать Апартаменты
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Home